import { FC } from "react";

import { Box, Grid, Stack } from "@mui/material";

type TicketingV2CoreInfoLayoutProps = {
  slots: {
    status?: React.ReactNode;
    formTitle: React.ReactNode;
    date?: React.ReactNode;
    location?: React.ReactNode;
    occurrenceSelector?: React.ReactNode;
  };
  isEmbed?: boolean;
};

export const TicketingV2CoreInfoLayout: FC<TicketingV2CoreInfoLayoutProps> = ({ slots, isEmbed = false }) => {
  const showDate = slots.date && !slots.occurrenceSelector;
  const hasBothItems = showDate && slots.location;
  const gridItemSize = hasBothItems ? 6 : 12;

  return (
    <Stack
      gap={2}
      width="100%"
      sx={{
        paddingBlockStart: { xs: 0, md: 3 },
        paddingBlockEnd: 1,
      }}
    >
      {slots.status && <Box sx={{ width: "fit-content" }}>{slots.status}</Box>}
      {!isEmbed && slots.formTitle}
      {(showDate || slots.location) && (
        <Grid container spacing={2}>
          {showDate && (
            <Grid item xs={12} md={gridItemSize}>
              {slots.date}
            </Grid>
          )}
          {slots.location && (
            <Grid item xs={12} md={gridItemSize}>
              {slots.location}
            </Grid>
          )}
        </Grid>
      )}
      {slots.occurrenceSelector}
    </Stack>
  );
};
